/**
 * Boost AI Search & Discovery (TURBO) — Custom JS Overrides
 *
 * Filter/sort/toolbar STYLING is controlled via the Boost Dashboard
 * (Visual Editor → Style Settings). This file handles only:
 *   - Overlay click-to-close (mobile filter drawer)
 *   - Hiding the "relevance" sort option
 */

(function () {
  'use strict';

  /* ──────────────────────────────────────────────
     HIDE "RELEVANCE" SORT OPTION
     ────────────────────────────────────────────── */
  function hideRelevanceSort() {
    document.querySelectorAll('[data-value="relevance"], [data-sort-value="relevance"]').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  /* ──────────────────────────────────────────────
     OVERLAY CLICK-TO-CLOSE (mobile filter drawer)
     ────────────────────────────────────────────── */
  function setupOverlayClose() {
    document.querySelectorAll('[class*="boost-sd"][class*="overlay"]').forEach(function (overlay) {
      if (overlay._sfBound) return;
      overlay._sfBound = true;
      overlay.addEventListener('click', function () {
        var close = document.querySelector('[class*="boost-sd"][class*="filter"][class*="close"]');
        if (close) close.click();
      });
    });
  }

  /* ──────────────────────────────────────────────
     TURBO EVENT LISTENERS
     ────────────────────────────────────────────── */
  document.addEventListener('boost-sd:filter-rendered', function () {
    hideRelevanceSort();
    setupOverlayClose();
  });

  document.addEventListener('boost-sd:product-list-rendered', function () {
    hideRelevanceSort();
  });

  document.addEventListener('boost-sd:sort-applied', function () {
    setTimeout(hideRelevanceSort, 300);
  });

  /* ──────────────────────────────────────────────
     INITIALIZATION
     ────────────────────────────────────────────── */
  function init() {
    hideRelevanceSort();
    setupOverlayClose();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
